import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDto } from '@api/core';
import { requiresPasswordChange } from '@shared/store/features/current-user.feature';
import { SharedComplianceStore } from 'app/compliance/shared-compliance.store';
import { waitToResolveSignal } from '@shared/utils/waitToResolve';
import { map } from 'rxjs';

export const complianceShellGuard: CanActivateFn = () => {
  const sharedComplianceStore = inject(SharedComplianceStore);
  const router = inject(Router);

  const cached = sharedComplianceStore.currentUser();
  if (cached) {
    return resolve(cached, router);
  }

  sharedComplianceStore.loadCurrentUser();

  return waitToResolveSignal(sharedComplianceStore.currentUserLoaded).pipe(
    map(() => resolve(sharedComplianceStore.currentUser(), router)),
  );
};

function resolve(user: UserDto | undefined, router: Router): boolean | ReturnType<Router['createUrlTree']> {
  if (!user) {
    return false;
  }
  if (requiresPasswordChange(user)) {
    return router.createUrlTree(['/change-password']);
  }
  if (user.role !== UserDto.RoleEnum.AdminCompliance) {
    return router.createUrlTree(['/']);
  }
  return true;
}
